/**
 * This categories list will be removed once we retrieve
 * the values from API.
 * https://bdnacorp.atlassian.net/browse/BULL-1174
 */
const Categories = {
	Software: [
		"Accounting",
		"Alerts and Monitoring Tools",
		"Analytics",
		"Anti Virus and Malware",
		"Application Architecture and Design",
		"Application Servers",
		"Application Testing and QA",
		"Archiving and Content Storage",
		"Backup and Recovery",
		"Banking",
		"Blogs & Wikis",
		"Business Intelligence (BI) Suites",
		"Business Metrics and Reporting Tools",
		"Business Performance Management",
		"Capacity Planning",
		"Cartography/Mapping",
		"CD & DVD Recording",
		"Collaboration Platforms",
		"Compiler and Decompiler",
		"Computer Hardware Configuration Management",
		"Computer-Based Training",
		"Conferencing",
		"Configuration Management Database (CMDB)",
		"Connectivity Tools",
		"Content Delivery and Distribution",
		"Cross-Industry ERP Suites",
		"Customer Relationship Management (CRM) Suites",
		"Customer Service & Support",
		"Data Mining and Warehousing",
		"Data Security and Encryption",
		"Demand Management",
		"Desktop Enhancements",
		"Desktop Publishing (DTP)",
		"Development Environment",
		"Dictionary and Encyclopedia",
		"Distribution and Transportation Management",
		"Document and Records Management",
		"Document Capturing and Imaging",
		"Drivers",
		"Electronic Design Automation",
		"Enterprise",
		"Enterprise Integration",
		"Fault Management",
		"File Managers",
		"Financial Management",
		"Financial Management Suites",
		"Firewall and Intrusion Prevention",
		"Games",
		"Graphics and Image Editing",
		"Hardware Virtualization",
		"Help and Service Desk",
		"Hospital Management",
		"Hypervisor",
		"IBM i",
		"Identity and Access Management",
		"Industry-Specific ERP Suites",
		"Instant Messaging",
		"Insurance",
		"Inventory Management",
		"Investment",
		"IT Asset Maintenance & Support",
		"IT Asset Management",
		"License Management",
		"Life Sciences",
		"Lifestyle and Personal Improvement",
		"Location-Aware Services",
		"Mac OS",
		"Mail Servers",
		"Mainframe",
		"Manufacturing Process Management",
		"Marketing Management",
		"Mathematics and Physics",
		"Mechanical CAD, CAM, and CAE Software",
		"Medical software",
		"Merchandising",
		"Multimedia Players",
		"Navigation Tools",
		"Network Performance Management",
		"Other Educational Software",
		"Other Engineering & Scientific Software",
		"Other Entertainment Software",
		"Other Hobbies Software",
		"Other Multimedia and Graphics Tools",
		"Other Operating Systems",
		"Other References Software",
		"Other Utilities",
		"Payment Systems",
		"Payroll & Time Accounting",
		"Peer-to-peer (P2P) Networking",
		"Personal",
		"PIM & Contact Managers",
		"Plant/Shop Control",
		"Point of Sale",
		"Presence",
		"Presentation",
		"Procurement and Sourcing",
		"Product and Portfolio Management",
		"Product Data Management",
		"Product Design",
		"Productivity Suites",
		"Recruitment & Training",
		"Regulatory and Compliance Management",
		"Religious Software",
		"Sales and Operations Planning",
		"Sales Management",
		"Security Suites",
		"Social Networking",
		"Software Configuration Management",
		"Software Virtualization",
		"Spatial Analysis",
		"Sports Software",
		"Spreadsheets",
		"Storage Resource Management",
		"Storage Virtualization",
		"Store Operations",
		"Supplier Relationship Management",
		"Supply Chain Management (SCM) Suites",
		"Synchronization Tools",
		"Taxation",
		"Unclassified Middleware",
		"Unclassified Software",
		"UNIX",
		"Video and Audio Editing",
		"Virtualization Management Software",
		"Vulnerability Management",
		"Warehouse Management System",
		"Web Browsers",
		"Web Content Management",
		"Web Design",
		"Web Servers",
		"Windows",
		"Word Processors",
		"Workflow and Business Process Management",
		"Workforce Management"
	],
	Hardware: [
		"Basic Mobile Phones",
		"Blade Enclosures",
		"Bridges",
		"Converged Infrastructure",
		"Copier",
		"CRT Displays",
		"Database Appliances",
		"Desktops",
		"Direct Attached Storage (DAS)",
		"Dot Matrix",
		"Fax Machine",
		"Feature Phones",
		"Firewalls and Security Appliances",
		"Flat Panel Displays",
		"Gateways",
		"Handhelds",
		"Handsets",
		"Hubs/Switches",
		"Human Interface Devices",
		"Imaging/Video Devices",
		"Inkjet Printers",
		"KVM Switches",
		"Labeling Devices",
		"Laser Printers",
		"Light Source System",
		"Load Balancers",
		"Mainframes",
		"Modems",
		"Multifunction",
		"Network Attached Storage (NAS)",
		"Notebooks",
		"Other Printing Devices",
		"Point of Sale (POS)",
		"Print Servers",
		"Projectors",
		"Rack Enclosures",
		"Routers",
		"Search Appliances",
		"Servers",
		"Smartphones",
		"Sound/Audio Devices",
		"Storage Area Networks (SAN)",
		"Tape Systems",
		"Telephone Exchanges",
		"Thermal Printers",
		"Thin Clients",
		"Unclassified Hardware",
		"Unclassified Network Equipment",
		"Unclassified Storage",
		"Voice and Multimedia Communication Systems",
		"Wireless Access Points",
		"Workstations"
	]
};

export default Categories;


// WEBPACK FOOTER //
// ./src/config/Categories.js